import StaffNavbar from '../components/StaffNavbar';
import FirstRewardsPreview from '../components/FirstRewardsPreview';
import '../styles/StaffPages.css';

const StaffInitialRewards = () => (
  <div className="admin-dashboard">
    <StaffNavbar activeSection="initial-rewards" />
    <div className="admin-main">
      <div className="admin-content">
        <h1 className="staff-page-header">Initial Rewards</h1>
        <p className="staff-page-subheader">
          The first-reward ladder students unlock as they earn points, shown the way it
          appears in the app.
        </p>

        <FirstRewardsPreview />
      </div>
    </div>
  </div>
);

export default StaffInitialRewards;
